import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {  Observable, Subscription, throwError } from "rxjs";
import {  catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { Store, select } from "@ngrx/store";
import { adminState } from "src/app/store/admin.reducers";
import * as adminProfileActions from "../../store/admin-actions";
 

@Injectable({
  providedIn: "root",
})
export class SharedService {
  constructor(
    private http: HttpClient,

    private store: Store<{ adminDetails: adminState }>
  ) {
    this.adminDetail$ = store.pipe(select("adminDetails"));
  }

  user: adminProfileActions.adminProfileDetails;


  adminDetail$: Observable<adminState>;
  storeSubscribe: Subscription;

  getInitialInfo(){
    this.store.dispatch(adminProfileActions.getInitialActions());

  }

  saveInitialDataInfo(obj) {
    this.store.dispatch(
      adminProfileActions.updateInitialActions({ info: obj })
    );

    this.store.dispatch(adminProfileActions.getInitialActions());

    // return new Promise((resolve, reject) => {

    //   this.members.getRegularMembers().subscribe((res) => {
    //     this.regularMembersData = res.data;
    //     this.initialDataDetails.actionItems.regular_members.data = this.regularMembersData;
    //   });
    //   this.fellowships.getFellowships().subscribe((res) => {
    //     this.fellowshipData = res.data;
    //     this.initialDataDetails.actionItems.house_fellowship.data = this.fellowshipData;
    //   });
    // });
  }
  getAdminDetails() {
    this.user = JSON.parse(localStorage.getItem("user_details"));
    // console.log(JSON.stringify(user))
    this.store.dispatch(
      adminProfileActions.updateAdminProfile({ details: this.user })
    );

    this.store.dispatch(adminProfileActions.getAdminProfile());

    //return  user
  }

  saveAdminDetails(obj) {
    console.log(obj);
    this.store.dispatch(
      adminProfileActions.updateAdminProfile({ details: obj })
    );

    this.store.dispatch(adminProfileActions.getAdminProfile());
    localStorage.setItem("user_details", JSON.stringify(obj));
  }
  getSlug() {
    let user = JSON.parse(localStorage.getItem("user_details"));
    return user.memberships[0].church.slug;
  }
  // getAdminDetails(): Observable<any> {
  //   return this.http
  //     .get<any>(`${environment.baseUrl}/admin/${this.getSlug()}/people/members`, {
  //       headers: new HttpHeaders({
  //         "Content-Type": "application/json",
  //         Accept: "application/json",
  //       })
  //     })
  //     .pipe(
  //       catchError(err => {
  //         return this.handleGenericError(err);
  //       })
  //     );
  // }

  searchMembers(query) {
    return this.http
      .get<any>(
        `${
          environment.baseUrl
        }/${this.getSlug()}/people/members/search?query=${query}`,
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            Accept: "application/json",
          }),
        }
      )
      .pipe(
        catchError((err) => {
          return this.handleGenericError(err);
        })
      );
  }

  searchDepartments(query) {
    return this.http
      .get<any>(
        `${
          environment.baseUrl
        }/${this.getSlug()}/departments/search?query=${query}`,
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            Accept: "application/json",
          }),
        }
      )
      .pipe(
        catchError((err) => {
          return this.handleGenericError(err);
        })
      );
  }

  getBanks() {
    return this.http
      .get<any>("https://api.paystack.co/bank", {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Accept: "application/json",
        }),
      })
      .pipe(
        catchError((err) => {
          return this.handleGenericError(err);
        })
      );
  }

  /*{
  "status": true,
  "message": "Banks retrieved",
  "data": [
    {
      "name": "Abbey Mortgage Bank",
      "slug": "abbey-mortgage-bank",
      "code": "801",
      "longcode": "",
      "gateway": null,
      "pay_with_bank": false,
      "active": true,
      "is_deleted": false,
      "country": "Nigeria",
      "currency": "NGN",
      "type": "nuban",
      "id": 174,
      "createdAt": "2020-12-07T16:19:09.000Z",
      "updatedAt": "2020-12-07T16:19:19.000Z"
    }, */

  handleGenericError(error) {
    console.error(error);
    return throwError(error);
  }
}
